import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import React, { useEffect } from 'react';
import { usePreparePayLoad } from './ocs-custom-events/helpers';
import { customUrlEventDispatcher } from 'components/common/ocs-custom-events/urlEvents';
import { handleLinkClicked } from './ocs-custom-events/linkEvents';
import { useGetEventUnits, useGetFunctionEventUnits } from 'helpers/commonCodes';

export const OcsCustomEvents = ({ children }) => {
  const params = useUrlFriendlyToParameters()
  const paramsURL = { ...params }
  const payloadParams = usePreparePayLoad()
  const  getEventUnits = useGetFunctionEventUnits()
  const { pathname } = payloadParams;
  const handleEventWithUnits = (e) => handleLinkClicked(e, getEventUnits, paramsURL);

    useEffect(() => {
      let root = document.getElementById("root")
      root.addEventListener("click", handleEventWithUnits);
  
      return () => {
        root.removeEventListener("click", handleEventWithUnits)
 
      }
    }, [])
  

    
    useEffect(() => {
        customUrlEventDispatcher({params: params, payloadParams: payloadParams})
    }, [pathname]);
 
    return <></>
  }

export default OcsCustomEvents;
